import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { GlobalComponent } from 'src/app/global-component';
import { TaskModel } from 'src/app/core/models/task/task.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { DataType } from 'src/app/core/models/document/custom-field-base-model';
import { BusinessUnit } from 'src/app/core/models/org/bussiness-unit.model';
import { StrategyModel } from 'src/app/core/models/strategy/strategy.model';
import { CustomFieldGroupModel } from 'src/app/core/models/myfile/custom-field-group.model';
import { CustomFieldModel } from 'src/app/core/models/document/custom-field-model';
import { AiApiService } from 'src/app/core/services/ai-api.service';

enum multiSelectDropDown {
  Unknown = 0,
  ExportClientStrategyBase = 1,
  ImportClientStrategyBase = 2
}

@Component({
  selector: 'app-task-modal',
  templateUrl: './task-modal.component.html',
  styleUrls: ['./task-modal.component.scss']
})
export class TaskModalComponent extends BaseModalComponent {

  emailPattern = GlobalComponent.emailPattern;
  datePattern = GlobalComponent.datePattern;

  securityPermissionTaskUpdate: boolean = true; //this.authMyFileService.canAccessOperation(SecurityOperations.account.accountDelete);

  @Input() public override model: TaskModel = new TaskModel;
  @Input() public entitiesToAdd: any[] = [];
  @Input() public  buttonName: string = "Execute";

  entityIds: string[] = [];
  tenantList: BusinessUnit[] = [];
  currentTenantId?: string;

  enumDataType = DataType;

  accordionData: CustomFieldGroupModel[] = []; 
  defaultCustomFieldGroup: CustomFieldGroupModel = new CustomFieldGroupModel();
  customFieldsGroups: CustomFieldGroupModel[] = [];
  activeIdIndex: number = 0;

  constructor(
    protected  aiApiService: AiApiService,
    protected override myFileApiService: MyfileApiService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer,
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  ngOnInit(): void {
    if (this.model.id === undefined) {
      this.newModel = true;
    }

    if (this.entitiesToAdd && this.entitiesToAdd.length > 0) {
      this.entitiesToAdd.forEach(entity => {
        if (entity.id) {
          this.entityIds.push(entity.id);
        }
      })
    }

    this.model.strategies.forEach((strategy: StrategyModel) => {
      strategy.customFields.forEach((customField:CustomFieldModel)=>{
        if(strategy.name === undefined && customField.groupName !== undefined ){
          strategy.name = customField.groupName; 
        }
        if(customField.dataType === DataType.CommaSeparated){
          this.entityIds.forEach(id => {
            if (customField.value === undefined) {
              customField.value= `${id}`;
            } else {
              customField.value = `${customField.value},${id}`;
            }
          })
        }
      })
    })

  }

  ngOnDestroy(): void {
    this.model = new TaskModel;
  }

  onUpdate(): void {
    this.submitted = true;
    this.disableEditing = true;

    this.aiApiService.updateTask(this.model).subscribe((result) => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@: Task Successfully Created `, $localize`:@@Toast_Success_GeneralTitle:Success`);
      }
      this.disableEditing = false;
    })
  }

  //this was added to prevent the flicker caused by converting the bool to a string on update/create
  checkBoolValue(value: string|boolean ): Boolean{
    if(value === "false" || value === false ){
      return false;
    }
    return true; 
  }

  onCreate(): void {
    this.submitted = true;
    this.model.strategies.forEach((strategy: StrategyModel) => {
      strategy.customFields.forEach((customField:CustomFieldModel)=>{ 
        if(customField.dataType === DataType.DropDown){
          customField.keyValues![customField.keyValues!.findIndex(element=>element.value == customField.value)].isSelected = true;
        }
        if(customField.dataType === DataType.Boolean){
          customField.value = `${customField.value}`; //Convert boolean to String since task end point expects String value for custom fields value
        }
      })
    })
    
    this.aiApiService.newTaskWithModel(this.model).subscribe((result) => {
      if (result && result.id) {
        this.aiApiService.executeTask(result.id).subscribe((result)=>{
          this.disableEditing = false;
          this.close();
        })
        this.disableEditing = false;
      }else{
        this.disableEditing = false;
        this.close();
      }
    })
  }

  validate() {
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

  checkDropdown(strategy$Type: string | undefined): multiSelectDropDown {
    if (strategy$Type !== undefined) {
      switch (strategy$Type) {
        case "ExportClientStrategyBase":
          return multiSelectDropDown.ExportClientStrategyBase;
      }
    }
    return multiSelectDropDown.Unknown;
  }

  camelCaseToRegularText(string: string | undefined) {
    if (string === undefined) {
      string = $localize`:@@:Unknown Strategy`;
    } else {
      string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
      string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    }
    return string;
  }
}
